module.exports = __webpack_public_path__ + "static/media/bombswap.3187de13.png";